import { ChangeDetectionStrategy, Component, inject, input, linkedSignal, output } from '@angular/core';
import { FormatPipe, selectDateRangeFn, DateRange } from '@softline/ui-core';
import { QueryBarItemComponent } from '../../query-bar/query-bar-item/query-bar-item.component';
import { DateService } from '@softline/core';

@Component({
  selector: 'soft-date-range-filter',
  imports: [
    FormatPipe,
    QueryBarItemComponent
  ],
  templateUrl: './date-range-filter.component.html',
  styleUrl: './date-range-filter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateRangeFilterComponent {
  dateService = inject(DateService);
  selectDateRange = selectDateRangeFn();

  valueInput = input<DateRange>({from: this.dateService.now(), to: this.dateService.now()}, {alias: 'value'});
  title = input.required<string>();
  valueChange = output<DateRange>();

  value = linkedSignal(() => this.valueInput());
  shortcuts = input<{value: DateRange, label: string}[] | null>(null);

  async onClick(): Promise<void> {
    const result = await this.selectDateRange({value: this.value(), shortcuts: this.shortcuts()});
    if(!result || result === 'DISMISSED')
      return;
    this.value.set(result);
    this.valueChange.emit(result);
  }
}
